import { UseSearchState } from '@propertypal/shared/src/hooks/useSearchState';
import { SearchState } from '@propertypal/shared/src/reducers/search';
import ToggleSwitch from '@propertypal/web-ui/src/inputs/ToggleSwitch';
import { InputLabel } from '@propertypal/web-ui/src/typography';
import React, { FunctionComponent } from 'react';
import { SmartColumn } from './SearchBar.style';

interface Props {
  filters: SearchState['filters'];
  isRental: boolean;
  handleFilterChange: UseSearchState['handleFilterChange'];
  isMobile: boolean;
}

const IncludeExcludeInputs: FunctionComponent<Props> = ({ filters, handleFilterChange, isRental, isMobile }) => {
  const columnStyle = { width: isMobile ? undefined : 216 };

  return (
    <>
      <SmartColumn mr={20} style={columnStyle}>
        <InputLabel>{isRental ? 'Let' : 'Sale'} Agreed Properties</InputLabel>
        <ToggleSwitch
          ariaLabel={`Include ${isRental ? 'Let' : 'Sale'} agreed properties`}
          checked={filters.includeAgreed}
          onValueChange={handleFilterChange('includeAgreed')}
          testID="checkItem-includeSaleAgreed"
        />
      </SmartColumn>

      {filters.category === 'residential' && filters.saleType === 'rent' && (
        <SmartColumn mr={20} style={columnStyle}>
          <InputLabel>Exclude Student Lettings</InputLabel>
          <ToggleSwitch
            ariaLabel="Exclude Student Lettings"
            checked={filters.excludeStudentLettings}
            onValueChange={handleFilterChange('excludeStudentLettings')}
            testID="checkItem-excludeStudentLettings"
          />
        </SmartColumn>
      )}

      {['residential', 'newhomes', 'student', 'holidayhomes'].includes(filters.category) &&
        filters.saleType === 'sale' && (
          <SmartColumn mr={20} style={columnStyle}>
            <InputLabel>Chain Free Properties{!isMobile ? ' Only' : ''}</InputLabel>
            <ToggleSwitch
              ariaLabel="Select Chain Free Properties Only"
              checked={(filters.tags && filters.tags.includes('chainFree')) || false}
              onValueChange={handleFilterChange('tags-chainFree')}
              testID="toggle-includeChainFree"
            />
          </SmartColumn>
        )}

      {((filters.category === 'residential' && filters.saleType === 'sale') || filters.category === 'newhomes') && (
        <SmartColumn style={columnStyle}>
          <InputLabel>Suitable for Co-Ownership</InputLabel>
          <ToggleSwitch
            ariaLabel="Suitable for Co-Ownership"
            checked={filters.coOwnership}
            onValueChange={handleFilterChange('coOwnership')}
            testID="checkItem-coown"
          />
        </SmartColumn>
      )}

      {filters.category === 'residential' && filters.saleType === 'sale' && (
        <SmartColumn style={columnStyle}>
          <InputLabel>Exclude New Homes</InputLabel>
          <ToggleSwitch
            ariaLabel="Exclude New Homes"
            checked={filters.excludeNewHomes}
            onValueChange={handleFilterChange('excludeNewHomes')}
            testID="checkItem-excludeNewHomes"
          />
        </SmartColumn>
      )}

      <SmartColumn style={columnStyle}>
        <InputLabel>Exclude Price Not Provided</InputLabel>
        <ToggleSwitch
          ariaLabel="Exclude Price Not Provided"
          checked={filters.excludePoa}
          onValueChange={handleFilterChange('excludePoa')}
          testID="checkItem-excludePoa"
        />
      </SmartColumn>
    </>
  );
};

export default IncludeExcludeInputs;
